var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "031a29c4bf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 125.292969 124.027344 L 145.152344 124.027344 L 145.152344 143.886719 L 125.292969 143.886719 Z M 125.292969 124.027344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "197307fbe4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.292969 0.0273438 L 20.152344 0.0273438 L 20.152344 19.886719 L 0.292969 19.886719 Z M 0.292969 0.0273438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d243298167"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 21,
    y: 0,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 6.64417e+58
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 146,
    y: 0,
    height: 150
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -0.000000000000000111, -0.000000000000007527)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0664417e53)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#353252",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.750001, 144.933986)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 62.234375 2.015625 C 52.503906 2.015625 43.84375 0.816406 36.25 -1.578125 C 28.664062 -3.984375 22.34375 -7.140625 17.28125 -11.046875 C 12.226562 -14.953125 8.359375 -19.238281 5.671875 -23.90625 L 20.9375 -42.546875 L 23.34375 -42.546875 C 27.5625 -36.273438 32.921875 -31.28125 39.421875 -27.5625 C 45.921875 -23.851562 53.523438 -22 62.234375 -22 C 69.660156 -22 75.257812 -23.566406 79.03125 -26.703125 C 82.8125 -29.835938 84.703125 -34.15625 84.703125 -39.65625 C 84.703125 -42.988281 84.09375 -45.773438 82.875 -48.015625 C 81.664062 -50.253906 79.648438 -52.175781 76.828125 -53.78125 C 74.015625 -55.382812 70.207031 -56.757812 65.40625 -57.90625 L 47.34375 -62.046875 C 34.726562 -64.921875 25.332031 -69.703125 19.15625 -76.390625 C 12.976562 -83.085938 9.890625 -91.78125 9.890625 -102.46875 C 9.890625 -110.40625 11.875 -117.382812 15.84375 -123.40625 C 19.8125 -129.425781 25.585938 -134.097656 33.171875 -137.421875 C 40.765625 -140.753906 49.84375 -142.421875 60.40625 -142.421875 C 71.226562 -142.421875 80.492188 -140.992188 88.203125 -138.140625 C 95.921875 -135.296875 102.4375 -130.929688 107.75 -125.046875 L 94.015625 -106.21875 L 91.625 -106.21875 C 87.65625 -110.382812 83.109375 -113.503906 77.984375 -115.578125 C 72.859375 -117.660156 67 -118.703125 60.40625 -118.703125 C 52.789062 -118.703125 47 -117.359375 43.03125 -114.671875 C 39.0625 -111.984375 37.078125 -108.269531 37.078125 -103.53125 C 37.078125 -99.113281 38.46875 -95.59375 41.25 -92.96875 C 44.03125 -90.34375 48.847656 -88.289062 55.703125 -86.8125 L 74.140625 -82.984375 C 87.773438 -80.097656 97.664062 -75.210938 103.8125 -68.328125 C 109.957031 -61.441406 113.03125 -52.460938 113.03125 -41.390625 C 113.03125 -32.617188 111.140625 -24.984375 107.359375 -18.484375 C 103.585938 -11.984375 97.890625 -6.941406 90.265625 -3.359375 C 82.648438 0.222656 73.304688 2.015625 62.234375 2.015625 Z M 62.234375 2.015625 "
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#031a29c4bf)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125, 124)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d243298167)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#197307fbe4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff4d61",
    d: "M 0.292969 0.0273438 L 20.152344 0.0273438 L 20.152344 19.886719 L 0.292969 19.886719 Z M 0.292969 0.0273438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.25a91d5781b342051dcd96bcc4b66899.svg";
export { ForwardRef as ReactComponent };